<template>
  <aside>
    <div v-if="token" class="ai-chatbot">
      <div
        v-if="!isChatActive"
        ref="chatbotIcon"
        class="starter"
        @mousedown="startDrag"
        @click="handleOpenChat"
      >
        <div>
          <v-img :src="require('@/assets/images/png/helmat.png')" height="22" width="22" />
        </div>
      </div>

      <div v-else class="chatWindow" :style="chatWindowStyle">
        <div v-if="showLoading" class="loader" :class="{ loaded: !showLoading }">
          <v-img width="122" :src="require('@/assets/images/svg/logoDark1.svg')"></v-img>
        </div>

        <div v-else class="chatContainer">
          <ChatMessage @close="handleCloseChat" />
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import { storeGetters } from '@/store/storeConstants'
import ChatMessage from './ChatMessage.vue'

export default {
  components: { ChatMessage },
  setup() {
    const token = computed(() => store.getters[`auth/${storeGetters.GET_AUTH_TOKEN}`])

    const isChatActive = ref(false)
    const showLoading = ref(false)
    const chatbotIcon = ref(null)

    const chatbotPosition = ref({ top: 0, left: 0 })
    const position = ref({ x: 10, y: 25 })
    const isDragging = ref(false)
    const offset = ref({ x: 0, y: 0 })

    const chatWindowStyle = computed(() => {
      return {
        top: `${chatbotPosition.value.top}px`,
        left: `${chatbotPosition.value.left}px`,
        right: 'auto',
        bottom: 'auto',
        position: 'absolute',
        maxWidth: '100%',
        zIndex: 999,
      }
    })

    const handleOpenChat = event => {
      if (isDragging.value) return

      const iconRect = chatbotIcon.value.getBoundingClientRect()
      const chatWindowWidth = 420
      const chatWindowHeight = 500
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight

      let top = iconRect.bottom
      let left = iconRect.left

      if (iconRect.bottom + chatWindowHeight > viewportHeight) {
        top = iconRect.top - chatWindowHeight
      }
      if (left + chatWindowWidth > viewportWidth) {
        left = viewportWidth - chatWindowWidth - 10
      }

      chatbotPosition.value = { top, left }

      showLoading.value = true
      isChatActive.value = true
      setTimeout(() => {
        showLoading.value = false
      }, 2000)
    }

    const handleCloseChat = () => {
      isChatActive.value = false
      showLoading.value = false
    }

    const startDrag = event => {
      isDragging.value = false
      offset.value = {
        x: event.clientX - chatbotIcon.value.getBoundingClientRect().left,
        y: event.clientY - chatbotIcon.value.getBoundingClientRect().top,
      }

      document.addEventListener('mousemove', onDrag)
      document.addEventListener('mouseup', stopDrag)
    }

    const onDrag = event => {
      isDragging.value = true
      const x = event.clientX - offset.value.x
      const y = event.clientY - offset.value.y
      chatbotIcon.value.style.left = `${x}px`
      chatbotIcon.value.style.top = `${y}px`
      chatbotIcon.value.style.right = 'auto'
      chatbotIcon.value.style.bottom = 'auto'
      chatbotIcon.value.style.position = 'fixed'
    }

    const stopDrag = () => {
      document.removeEventListener('mousemove', onDrag)
      document.removeEventListener('mouseup', stopDrag)

      setTimeout(() => {
        isDragging.value = false
      }, 100)
    }

    onMounted(() => {
      if (chatbotIcon.value) {
        chatbotIcon.value.style.right = `${position.value.x}px`
        chatbotIcon.value.style.bottom = `${position.value.y}px`
      }
    })

    return {
      token,
      isChatActive,
      showLoading,
      handleOpenChat,
      handleCloseChat,
      chatbotIcon,
      startDrag,
      chatWindowStyle,
      isDragging,
      offset,
    }
  },
}
</script>
<style scoped lang="scss">
.v-image__image {
  background-position: 10% 50% !important;
  background-size: 125px !important;
}
.ai-chatbot {
  .starter {
    position: fixed;
    right: 10px;
    bottom: 25px;
    width: 50px;
    height: 50px;
    background-color: #fe724c5c;
    border-radius: 50%;
    margin: 10px;
    cursor: pointer;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1,
  }

  .chatWindow {
    width: 420px;
    height: 500px;
    background: #fff;
    bottom: 0;
    position: fixed;
    right: 0;
    // margin: 10px;
    overflow: hidden;
    border-radius: 16px;
    border: 1px solid #999999;
    box-shadow: 0px 1px 3px 0px #19213d1a;

    .loader {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
      top: 0;
      background-color: #ccc;
      background-color: #10294c;
      transform: translateY(0);
      transition: all 0.2s ease-out;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .loader.loaded {
      transform: translateY(100%);
    }
  }
}

.chatContainer {
  height: 100%;
}

.chatWindow {
  @media (max-width: 450px) {
    width: 95% !important;
    height: 90% !important;
  }
}
</style>
